import moment from "moment-timezone";

export const API_ESA_OFFICE = "https://esa-office.rotendaokab.go.id/api/";
//"https://esa-office.rotendaokab.go.id/api/";
//"http://localhost:5000/api/";
export const API_ESA_OFFICE_UPLOAD = "https://esa-office.rotendaokab.go.id";
//"http://localhost:5000";
//"https://esa-office.rotendaokab.go.id";
export const API_CHAT = "https://esa-office.rotendaokab.go.id/api/chat/";
//"https://chat.esa-office.rotendaokab.go.id/api/chat/";

export const DOMAIN_ESA_OFFICE = "https://esa-office.rotendaokab.go.id/";

export const ADMINS_LOGIN = API_ESA_OFFICE + "admin/login";
export const ADMINS_LOGOUT = API_ESA_OFFICE + "admin/logout";

export const API_TIMEOUT = 120000;

export const WAKTU_KERJA5 = {
  1: "9:00",
  2: "9:00",
  3: "9:00",
  4: "9:00",
  5: "9:30",
};

export const WAKTU_KERJAShift = {
  pagi: "6:00",
  siang: "6:00",
  malam: "12:00",
};

export const WAKTU_KERJA6 = {
  1: 7,
  2: 7,
  3: 7,
  4: 7,
  5: 4,
  6: 7,
};

export const ORIGIN_CITY = "383";

export function getDatesWithoutWeekends(startDateStr, endDateStr, libur) {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  const dates = [];

  while (startDate <= endDate) {
    if (startDate.getDay() !== 0 && startDate.getDay() !== 6) {
      // 0 adalah Minggu dan 6 adalah Sabtu
      dates.push(new Date(startDate)); // Menambahkan tanggal ke list dengan membuat salinan object Date-nya
    }

    startDate.setDate(startDate.getDate() + 1); // Memajukan tanggal ke hari berikutnya
  }

  // Konversi array date menjadi array of objects dengan properti 'tanggal'
  const formattedDates = dates.map((date) => ({
    tanggal: date.toISOString().slice(0, 10),
  }));

  // Membuang tanggal yang sesuai dengan tanggal libur
  const datesWithoutLibur = formattedDates.filter((item) => {
    let liburKu = false;

    libur.map((item2) => {
      if (item.tanggal == item2.tanggal) {
        liburKu = true;
      }
    });
    return liburKu == false;
  });

  const datesKu = datesWithoutLibur.map((item) => {
    const dateObj = new Date(item.tanggal);
    const dayOfWeek = dateObj.getUTCDay();

    // Mendapatkan waktu kerja dari hari yang sesuai dalam format "jam:menit"
    const waktuKerja = WAKTU_KERJA5[dayOfWeek] || "0:00";

    return { ...item, waktuKerja: waktuKerja };
  });

  return datesKu;
}

export function getDatesWithoutWeekendsShift(startDateStr, endDateStr, libur) {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  const dates = [];

  while (startDate <= endDate) {
    dates.push(new Date(startDate)); // Menambahkan tanggal ke list dengan membuat salinan object Date-nya

    startDate.setDate(startDate.getDate() + 1); // Memajukan tanggal ke hari berikutnya
  }

  // Konversi array date menjadi array of objects dengan properti 'tanggal'
  const formattedDates = dates.map((date) => ({
    tanggal: date.toISOString().slice(0, 10),
  }));

  // Membuang tanggal yang sesuai dengan tanggal libur
  const datesWithoutLibur = formattedDates.filter((item) => {
    let liburKu = false;

    libur.map((item2) => {
      if (item.tanggal == item2.tanggal) {
        liburKu = true;
      }
    });
    return liburKu == false;
  });

  const datesKu = datesWithoutLibur.map((item) => {
    const dateObj = new Date(item.tanggal);
    const dayOfWeek = dateObj.getUTCDay();

    // Mendapatkan waktu kerja dari hari yang sesuai dalam format "jam:menit"
    const waktuKerja = "6:00";

    return { ...item, waktuKerja: waktuKerja };
  });

  return datesKu;
}

export function convertDecimalHoursToTime(decimalHours) {
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
}
export function hitungtotaljamkerja(resultArray) {
  // Menghitung total waktu kerja dalam menit
  const totalWaktuKerjaMinutes = resultArray.reduce(
    (acc, item) => acc + convertToMinutes(item.waktuKerja),
    0
  );

  // Mengkonversi totalWaktuKerjaMinutes kembali ke format jam:menit
  const totalWaktuKerja = convertFromMinutes(totalWaktuKerjaMinutes);
  return totalWaktuKerja;
}

export function convertToMinutes(timeStr) {
  const [hours, minutes] = timeStr.split(":").map(Number);
  return hours * 60 + minutes;
}

export function convertFromMinutes(minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}:${String(remainingMinutes.toFixed(0)).padStart(2, "0")}`;
}

export function leftJoin(A, B, keyA, keyB) {
  const resultArray = A.map((itemA) => {
    let match = B.find((itemB) => itemB[keyB] === itemA[keyA]);

    // Mengambil hari dari tanggal
    const dateObj = new Date(itemA[keyA]);
    const dayOfWeek = dateObj.getUTCDay();

    // Mendapatkan waktu kerja dari hari yang sesuai dalam format "jam:menit"
    const waktuKerja = WAKTU_KERJA5[dayOfWeek] || "0:00";

    let workingHoursInMinutes = convertToMinutes("0:00");

    if (match && match.status == "Dinas Luar") {
      workingHoursInMinutes = convertToMinutes(waktuKerja);
      match.workingHours = waktuKerja;
    } else if (match && match.waktuMasuk && match.waktuPulang) {
      const wh = hitungSelisihWaktu(match.waktuMasuk, match.waktuPulang);
      match.workingHours = wh;
      workingHoursInMinutes = convertToMinutes(wh);
    } else if (match && !match.workingHours) {
      workingHoursInMinutes = convertToMinutes("0:00");
      match.workingHours = "0:00";
    } else if (!match) {
      match = {};
      match.workingHours = "0:00";
    }

    // Menghitung persentase

    const waktuKerjaInMinutes = convertToMinutes(waktuKerja);
    const persentase = workingHoursInMinutes / waktuKerjaInMinutes;

    return {
      ...itemA,
      ...(match || {}),
      waktuKerja,
      persentase, // Menambahkan properti persentase
    };
  });

  // Menghitung total waktu kerja dalam menit
  const totalWaktuKerjaMinutes = resultArray.reduce(
    (acc, item) => acc + convertToMinutes(item.waktuKerja),
    0
  );

  // Mengkonversi totalWaktuKerjaMinutes kembali ke format jam:menit
  const totalWaktuKerja = convertFromMinutes(totalWaktuKerjaMinutes);

  // Menghitung total workingHours dalam menit
  const totalWorkingMinutes = resultArray.reduce((acc, item) => {
    const [hours, minutes] = item.workingHours.split(":").map(Number);
    return acc + hours * 60 + minutes;
  }, 0);

  // Mengkonversi totalWorkingMinutes kembali ke format jam:menit
  const totalWorkingHours = convertFromMinutes(totalWorkingMinutes);

  return {
    total_waktukerja: totalWaktuKerja,
    total_harikerja: resultArray.length,
    total_workingHours: totalWorkingHours,
    data: resultArray,
  };
}

export function leftJoinShift(A, B, keyA, keyB) {
  const resultArray = A.map((itemA) => {
    let match = B.find((itemB) => itemB[keyB] === itemA[keyA]);

    // Mengambil hari dari tanggal
    const dateObj = new Date(itemA[keyA]);
    const dayOfWeek = dateObj.getUTCDay();

    // Mendapatkan waktu kerja dari hari yang sesuai dalam format "jam:menit"
    const waktuKerja = WAKTU_KERJAShift[match && match.status] || "6:00";

    let workingHoursInMinutes = convertToMinutes("0:00");

    if (match && match.waktuMasuk && match.waktuPulang) {
      match.workingHours = match.workingHoursKu;
      workingHoursInMinutes = convertToMinutes(match.workingHoursKu);
    } else if (match && !match.workingHours) {
      workingHoursInMinutes = convertToMinutes("0:00");
      match.workingHours = "0:00";
    } else if (!match) {
      match = {};

      match.workingHours = "0:00";
    }

    // Menghitung persentase

    const waktuKerjaInMinutes = convertToMinutes(waktuKerja);
    const persentase = workingHoursInMinutes / waktuKerjaInMinutes;

    return {
      ...itemA,
      ...(match || {}),
      waktuKerja,
      persentase, // Menambahkan properti persentase
    };
  });

  // Menghitung total waktu kerja dalam menit
  const totalWaktuKerjaMinutes = resultArray.reduce(
    (acc, item) => acc + convertToMinutes(item.waktuKerja),
    0
  );

  // Mengkonversi totalWaktuKerjaMinutes kembali ke format jam:menit
  const totalWaktuKerja = convertFromMinutes(totalWaktuKerjaMinutes);

  // Menghitung total workingHours dalam menit
  const totalWorkingMinutes = resultArray.reduce((acc, item) => {
    const [hours, minutes] = item.workingHours.split(":").map(Number);
    return acc + hours * 60 + minutes;
  }, 0);

  // Mengkonversi totalWorkingMinutes kembali ke format jam:menit
  const totalWorkingHours = convertFromMinutes(totalWorkingMinutes);

  return {
    total_waktukerja: totalWaktuKerja,
    total_harikerja: resultArray.length,
    total_workingHours: totalWorkingHours,
    data: resultArray,
  };
}

export function getTimeKu() {
  const time = moment.tz("Asia/Makassar");

  // Format the time and store it in state
  const formattedTime = {
    datetime: time.format("MM/DD/YYYY, hh:mm:ss.SSSSSS A") + time.format("Z"),
    utc_offset: time.format("Z"),
    timezone: "Asia/Makassar",
  };

  return formattedTime;
}

export function hitungSelisihWaktu(waktuMasuk, waktuPulang) {
  // Mengubah waktu ke objek Date
  if (waktuMasuk !== "" && waktuPulang !== "") {
    const waktuAwal = new Date(`1970-01-01T${waktuMasuk}:00`);
    const waktuAkhir = new Date(`1970-01-01T${waktuPulang}:00`);

    // Menghitung selisih dalam milidetik dan konversi ke menit
    const selisih = (waktuAkhir - waktuAwal) / 1000 / 60;

    // Menghitung jam dan menit
    const jam = Math.floor(selisih / 60);
    const menit = selisih % 60;

    // Mengembalikan waktu dalam format "hh:mm"
    return `${jam.toString().padStart(2, "0")}:${menit
      .toString()
      .padStart(2, "0")}`;
  } else {
    return "00:00";
  }
}

/**
 * Fetch notification count untuk instruksi
 * @param {number} userId - User ID
 * @returns {Promise<{instruksi_baru: number, instruksi_selesai_belum_respon: number}>}
 */
export async function fetchInstruksiNotificationCount(userId) {
  const url = `${API_ESA_OFFICE}instruksi/notifikasi/count/${userId}`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return {
      instruksi_baru: data.instruksi_baru || 0,
      instruksi_selesai_belum_respon: data.instruksi_selesai_belum_respon || 0,
    };
  } catch (error) {
    console.error("Error fetching instruksi notification count:", error);
    return {
      instruksi_baru: 0,
      instruksi_selesai_belum_respon: 0,
    };
  }
}

/**
 * Fetch notification count untuk disposisi
 * @param {number} userId - User ID
 * @returns {Promise<{surat_masuk_belum_disposisi: number, disposisi_baru: number, disposisi_selesai_belum_respon: number}>}
 */
export async function fetchDisposisiNotificationCount(userId) {
  const url = `${API_ESA_OFFICE}disposisi/notifikasi/count/${userId}`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return {
      surat_masuk_belum_disposisi: data.surat_masuk_belum_disposisi || 0,
      disposisi_baru: data.disposisi_baru || 0,
      disposisi_selesai_belum_respon: data.disposisi_selesai_belum_respon || 0,
    };
  } catch (error) {
    console.error("Error fetching disposisi notification count:", error);
    return {
      surat_masuk_belum_disposisi: 0,
      disposisi_baru: 0,
      disposisi_selesai_belum_respon: 0,
    };
  }
}

/**
 * Fetch semua notification count dalam 1 request (instruksi + disposisi)
 * @param {number} userId - User ID
 * @returns {Promise<{instruksi: {instruksi_baru: number, instruksi_selesai_belum_respon: number}, disposisi: {surat_masuk_belum_disposisi: number, disposisi_baru: number, disposisi_selesai_belum_respon: number}}>}
 */
export async function fetchAllNotificationCount(userId) {
  const url = `${API_ESA_OFFICE}instruksi/notifikasi/all/${userId}`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return {
      instruksi: {
        instruksi_baru: data.instruksi?.instruksi_baru || 0,
        instruksi_selesai_belum_respon:
          data.instruksi?.instruksi_selesai_belum_respon || 0,
      },
      disposisi: {
        surat_masuk_belum_disposisi:
          data.disposisi?.surat_masuk_belum_disposisi || 0,
        disposisi_baru: data.disposisi?.disposisi_baru || 0,
        disposisi_selesai_belum_respon:
          data.disposisi?.disposisi_selesai_belum_respon || 0,
      },
    };
  } catch (error) {
    console.error("Error fetching all notification count:", error);
    return {
      instruksi: {
        instruksi_baru: 0,
        instruksi_selesai_belum_respon: 0,
      },
      disposisi: {
        surat_masuk_belum_disposisi: 0,
        disposisi_baru: 0,
        disposisi_selesai_belum_respon: 0,
      },
    };
  }
}
